import type { EstimatedStatusEnum } from 'js/src/client';

export enum SHARE_VIDEO_ACTIONS {
    STORE_VIDEO = 'STORE_VIDEO',
    STORE_PROJECT = 'STORE_PROJECT',
    STORE_RENDER_ESTIMATE = 'STORE_RENDER_ESTIMATE',
    STORE_VIDEO_MEMBERS = 'STORE_VIDEO_MEMBERS',
    SET_LOADING_FINISHED = 'SET_LOADING_FINISHED',
    SET_VIDEO_VISIBILITY = 'SET_VIDEO_VISIBILITY',
    START_AUTO_DOWNLOAD = 'START_AUTO_DOWNLOAD',
    SET_VIDEO_STATUS = 'SET_VIDEO_STATUS',
    SET_VIDEO_NAME = 'SET_VIDEO_NAME',
}

// matches VideoRenderDetails endpoint response type
export type PublicVideoRenderEstimate = {
    estimated_status: EstimatedStatusEnum;
    estimated_time_remaining: number;
};

// shown in the video details page when something happens
export type ShareVideoNotification = {
    msg: string;
    type: string;
    source: string;
    translated_video_id?: number;
};
